import { render, staticRenderFns } from "./SideBarBilling.vue?vue&type=template&id=a50805f4"
import script from "./SideBarBilling.vue?vue&type=script&lang=js"
export * from "./SideBarBilling.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports